;(function () {
  'use strict'

  angular
    .module('contrast.compliance-policy')
    .controller('CompliancePolicyCtrl', CompliancePolicyCtrl)

  function CompliancePolicyCtrl(
    $scope,
    $timeout,
    compliancePolicyService,
    PromiseService
  ) {
    'ngInject'

    var _searchKeywords, lastSearch

    angular.extend($scope, {
      loadByScroll: loadByScroll,
      order: order,
      toggleEnabled: toggleEnabled,
      launchDeleteDialog: launchDeleteDialog,
      searchKeywords: searchKeywords,
      showAllCriteria: showAllCriteria,
      showAllApps: showAllApps
    })

    function init() {
      _setDefaults()
      _getPolicies($scope.data.numPerLoad, 0)
    }

    function _setDefaults() {
      _searchKeywords = ''

      angular.extend($scope, {
        data: {
          numPerLoad: 10,
          loadPromise: null,
          busy: true,
          total: 0,
          policies: [],
          row: 'name'
        }
      })
    }

    function loadByScroll() {
      if ($scope.data.busy) {
        return
      }

      $scope.data.loadPromise = _getPolicies(
        $scope.data.numPerLoad,
        $scope.data.policies.length
      )
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }

      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }

      _loadByRefresh()

      return _searchKeywords
    }

    function order(rowName) {
      if ($scope.data.row === rowName) {
        return
      }

      $scope.data.row = rowName
      _loadByRefresh()
    }

    function toggleEnabled(policy) {
      compliancePolicyService
        .togglePolicyStatus(policy.policy_id)
        .catch(function () {
          policy.enabled = !policy.enabled
        })
    }

    function launchDeleteDialog(policy) {
      return compliancePolicyService
        .confirmAndDelete(policy)
        .then(_loadByRefresh)
    }

    function showAllCriteria(policy) {
      policy.limitCriteria = 'Infinity'
    }

    function showAllApps(policy) {
      policy.limitApplication = 'Infinity'
    }

    function _getPolicies(limit, offset) {
      if (lastSearch) {
        PromiseService.cancelPromise(lastSearch)
      }

      $scope.data.busy = true

      lastSearch = compliancePolicyService.getPolicies(
        limit,
        offset,
        searchKeywords(),
        $scope.data.row
      )

      return lastSearch
        .then(function (data) {
          $scope.data.policies = $scope.data.policies.concat(data.policies)
          $scope.data.total = data.count

          $timeout(function () {
            $scope.$emit('triggerScrollCheck')
          })
        })
        .finally(function () {
          if ($scope.data.policies.length < $scope.data.total) {
            $scope.data.busy = false
          }
        })
    }

    function _loadByRefresh() {
      _clearPolicies()
      $scope.data.loadPromise = _getPolicies($scope.data.numPerLoad, 0)
    }

    function _clearPolicies() {
      $scope.data.policies = []
    }

    init()
  }
})()
